import { DecimalPipe, LowerCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxAmountPipe,
  OnyxInformationHeadingComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
} from '@onyx/angular';
import { ContractorPaymentTermComponent } from '../../../dashboard/management-panel/contractors/common/components/contractor-payment-term/contractor-payment-term.component';
import type { ContractorPayment } from '../../../dashboard/management-panel/contractors/common/interfaces/contractor';

@Component({
  selector: 'app-contractor-payment',
  imports: [
    OnyxInformationRowComponent,
    ContractorPaymentTermComponent,
    OnyxAmountPipe,
    DecimalPipe,
    TranslatePipe,
    LowerCasePipe,
    OnyxInformationListComponent,
    OnyxInformationHeadingComponent,
  ],
  templateUrl: './contractor-payment.component.html',
  styleUrl: './contractor-payment.component.scss',
})
export class ContractorPaymentComponent {
  public readonly payment = input.required<ContractorPayment>();
}
